import { createContext } from 'react';

interface GameContextProps {
  isSingleTable: boolean;
}

export const GameContext = createContext<GameContextProps>({
  isSingleTable: true,
});
